import { Card } from "primereact/card";
import { Dialog } from "primereact/dialog";

import { C, themeClasses as T } from "../../../utils";
import { Skeleton } from "primereact/skeleton";

export const NavContact = ({
  isVisible,
  onVisibilityChange,
  contacts,
  testId = "nav-contact-dialog",
}: {
  isVisible: boolean;
  onVisibilityChange: (value: boolean) => void;
  contacts?: string | null;
  /** data-testid applied to the contact Dialog. */
  testId?: string;
}) => {
  return (
    <div className="card flex justify-content-center">
      <Dialog
        header="Contact Your Security Team"
        visible={isVisible}
        data-testid={testId}
        draggable={false}
        style={{ width: "50vw" }}
        onHide={() => onVisibilityChange(false)}
      >
        <div className="flex flex-col gap-8">
          <p>
            Your questions and comments are crucial. We are your security team, so please contact us
            and let&#39;s have a conversation.
          </p>
          <Card className={C(T.bgElevation2, "whitespace-pre-line")}>
            {contacts ? <p>{contacts}</p> : <ContactSkeleton />}
          </Card>
        </div>
      </Dialog>
    </div>
  );
};

const ContactSkeleton = () => (
  <div className="flex flex-col gap-2">
    <Skeleton width="60%" />
    <Skeleton width="80%" />
    <Skeleton width="90%" />
    <Skeleton width="70%" />
  </div>
);
